import { BPanel, Breadcrumb } from '@sketchpixy/rubix';
import { Link, withRouter } from 'react-router';
import { TextField, SubmitField } from 'uniforms-bootstrap3';
import React from 'react';
import _ from 'lodash';

import { Meteor } from 'meteor/meteor';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';

import { Reactive } from '../common/Reactive.mixin';

import { UserSchema } from '../../collections/users/users';
import { updatePassword } from '../../collections/users/methods';
import MgfForm from '../common/mgfForm';

@Reactive({
	subscriptions: ["users"]
})
@withRouter
export default class UserEditPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};

		if (!this.props.params.id)
			this.props.router.push('/users');
		else

		this.ChangePasswordSchema = new SimpleSchema({
			"password": {
				type: String,
				label: "Mot de passe",
				min: 8,
				uniforms: {
					type: "password"
				}
			}
		});
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.isReady && !this.props.isReady) {
			this.setState({
				user: Meteor.users.findOne({_id: this.props.params.id})
			});
		}
	}

	handleSubmit(doc) {
		this.props.router.push('/users');
	}

	handlePasswordChange(doc) {
		let that = this;
		return new Promise((resolve, reject) => {
			updatePassword.call(_.pick(doc, '_id', 'password'),
								(error, result) => {
									console.error(error);
									if (!error) {
										resolve(doc);
										that.props.router.push('/users');
									}
									reject(error);
								});
		});
	}

	render() {
		return (
			<div>
				<Breadcrumb>
					<Breadcrumb.Item>
						<Link to="/users">Utilisateurs</Link>
					</Breadcrumb.Item>
					<Breadcrumb.Item href="#" active>
						Modifier un utilisateur
					</Breadcrumb.Item>
				</Breadcrumb>
				<BPanel header="Modifier l'utilisateur">
					{ this.props.isReady &&
						<MgfForm schema={UserSchema} collection={Meteor.users} model={this.state.user} onSubmit={this.handleSubmit.bind(this)} />
					}
				</BPanel>
				<BPanel header="Mettre à jour le mot de passe">
					<MgfForm schema={this.ChangePasswordSchema} collection={ { label: "Le mot de passe" } } model={this.state.user} doSave={false} onSubmit={this.handlePasswordChange.bind(this)}>
						<TextField name="password" />
						<SubmitField value="Changer" />
					</MgfForm>
				</BPanel>
			</div>
		);
	}
}




/** WEBPACK FOOTER **
 ** ./src/universal/components/users/UserEdit.page.js
 **/